import { faCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Icon, Timeline } from "antd";
import React from 'react';
export var TTRTimeline = function (_a) {
    var timeline = _a.timeline;
    return (React.createElement("div", null,
        React.createElement(Timeline, null, timeline.map(function (item, index) {
            return React.createElement(Timeline.Item, { className: 'ttr-timeline-item', key: index, dot: React.createElement(Icon, { className: "color-gray-5", style: { fontSize: '8px' }, component: function () { return React.createElement(FontAwesomeIcon, { size: 'xs', icon: faCircle }); } }) },
                React.createElement("div", { className: 'ttr-timeline-message' },
                    React.createElement("div", { style: { flex: 4, }, className: 'ttr-text' }, item.description),
                    React.createElement("div", { style: { flex: 1, display: 'flex', justifyContent: 'flex-end' }, className: 'ttr-mute-text' }, item.timestamp)));
        }))));
};
//# sourceMappingURL=timeline.js.map